import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./SkillTemplates.scss";

const SkillTemplates = () => {
  // Définition du titre de la page
  UseTitle("Liste des compétences");

  const { isAdmin } = useAuth();

  const [listSkillTemplates, setListSkillTemplates] = useState([]);
  const [listInfos, setListInfos] = useState([]);

  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [search, setSearch] = useState("");
  const [ordering, setOrdering] = useState("name");
  const [pageSize, setPageSize] = useState(12);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const handlePageChange = (newPage) => setPage(newPage);

  useEffect(() => {
    const fetchSkillTemplates = async () => {
      if (listSkillTemplates.length === 0) setIsInitialLoading(true);
      else setIsRefreshing(true);

      try {
        const response = await api.get(
          `/skilltemplate/?search=${search}&ordering=${ordering}&page_size=${pageSize}&page=${page}`
        );
        setListSkillTemplates(response.data.results);
        setListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsInitialLoading(false);
        setIsRefreshing(false);
      }
    };

    fetchSkillTemplates();
  }, [search, ordering, page, pageSize]);

  return (
    <div className="skill-templates list-page">
      <div className="title">
        <h1>Liste des compétences</h1>
        {isAdmin && (
          <button className="bt" onClick={() => navigate("/skill/new")}>
            Ajouter une compétence
          </button>
        )}
      </div>

      {/* Filtres */}
      <div className="filters">
        <div>
          <label htmlFor="search">Rechercher </label>
          <input
            type="text"
            id="search"
            name="search"
            value={search}
            onChange={(event) => (setSearch(event.target.value), setPage(1))}
          />
        </div>
        <div>
          <label htmlFor="ordering">Trier par </label>
          <select
            id="ordering"
            name="ordering"
            value={ordering}
            onChange={(event) => setOrdering(event.target.value)}
          >
            <option value="name">Ascendant</option>
            <option value="-name">Descendant</option>
          </select>
        </div>
        <div>
          <label htmlFor="pagesize">Nombre d'affichage </label>
          <select
            id="pagesize"
            name="pagesize"
            value={pageSize}
            onChange={(event) => (setPageSize(event.target.value), setPage(1))}
          >
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="48">48</option>
          </select>
        </div>

        {listSkillTemplates.length != 0 && (
          <h2>Compétences ({listInfos.count})</h2>
        )}
      </div>

      {/* Chargment Initial */}
      {isInitialLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}

      {/* Chargement des compétences */}
      {!isInitialLoading &&
        (listSkillTemplates.length === 0 ? (
          <div className="no-data">
            <p>
              <strong>Aucune compétence trouvée</strong>
            </p>
          </div>
        ) : (
          <div className={`list-div ${isRefreshing ? "loading" : ""}`}>
            {listSkillTemplates.map((skillTemplate) => (
              <NavLink
                key={skillTemplate.id}
                className="list-card"
                to={`/skill/${skillTemplate.id}`}
              >
                <h3>{skillTemplate.name}</h3>
                {/* <div className="description">{skillTemplate.description}</div> */}
                <div>
                  <small>
                    (
                    {skillTemplate.attributes.map((attribute, index) => (
                      <span className="attributes" key={index}>
                        {index !== 0 && ", "}
                        {attribute.full_name}
                      </span>
                    ))}
                    )
                  </small>
                </div>
              </NavLink>
            ))}
          </div>
        ))}

      {/* Pagination */}
      {!isInitialLoading && listSkillTemplates.length > 0 && (
        <div className="pagination">
          <button
            className={page <= 1 ? "bt disabled" : "bt"}
            onClick={() => handlePageChange(page - 1)}
            disabled={page <= 1}
          >
            &lt;&lt;
          </button>
          <span>
            {page} / {Math.ceil(listInfos.count / pageSize)}
          </span>
          <button
            className={
              page >= Math.ceil(listInfos.count / pageSize)
                ? "bt disabled"
                : "bt"
            }
            onClick={() => handlePageChange(page + 1)}
            disabled={page >= Math.ceil(listInfos.count / pageSize)}
          >
            &gt;&gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default SkillTemplates;
